import React,{useState,useRef,useEffect} from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import Cleave from 'cleave.js/react'
import { Formik, Field, FieldArray } from 'formik'
import { Form, Input, TextArea, Button, Select, Step, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment, TableBody, TableCell, TableRow } from 'semantic-ui-react'

import Spinner from '../../services/spinner'
import AlertMessage from '../../services/alert'
import AlertConfirmation from '../../services/confirmation'

import { WindowReload, WindowURL, WindowLocation, RouteURL, RedirectURL, CurrencySymbol } from '../../services/redirect'
import { ValidateForm } from '../../validations/schemaProduct'
import { DropdownComponent } from '../../components/options'
import AuthDenied from '../ErrorPage/denied'


export default function EditProductComponent(props){

  const params = useParams();



  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [submitSpinner, setsubmitSpinner] = useState(false);
  const [spinner,setspinner] = useState(true);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
    }
  }


  /*------------------------------------------------------
    ALERT MESSAGE NOTIFY
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
    }
  }



  /*----------------------------------------
    Handle Form Submit
  -----------------------------------------*/
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }
  const [state, setState] = useState({
    id:'',
    exact_guid:'',
    exact_guid_copy:'',
    search_param:'',
    exact_selected:0,
    code:'',
    price:'0.00',
    status:'1',
    description:'',
    product_compliance:[],
    country_compliance:[]
  });

  function handleSubmitForm(values, props){


    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:""}});
    setsubmitSpinner(true);

    let formData = new FormData();
    formData.append('type','update');
    formData.append('info',JSON.stringify(values));
    axios.post('/admin/products/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setsubmitSpinner(false);

      if(obj=='success'){
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}});
        setnotify(true);
        setTimeout(function() {setnotify(false);},2000);
        if(buttonclick==1){
          setTimeout(function() {
            WindowLocation('/products/list');
          },2000);
        }else{
          setTimeout(function() {
            WindowReload();
          },2000);
        }
        return false;
      }


      if(obj=='error'){
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Something Wrong!',text:'Failed to connect through the server.'}});
        setnotify(true);
        setTimeout(function() {
          setnotify(false);
        },3000);
        return false;
      }

      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Input Error!',text:'Please correct the required fields.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },3000);

      Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

    })
    .catch(function (error){
      setsubmitSpinner(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },3000);
    });


  }

  /*------------------------------------------------------
          Product Details
  -------------------------------------------------------*/
  function ProductDetails(id){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','details');
    formData.append('id',id);
    axios.post('/admin/products/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setspinner(false);

      if(obj==0){
        WindowLocation('/products/list');
        return false;
      }

      setState({
        ...state,
        id:obj.id,
        exact_guid:obj.exact_guid,
        exact_guid_copy:obj.exact_guid,
        name:obj.name,
        code:obj.code,
        price:obj.price,
        status:obj.status,
        description:obj.description,
        product_compliance:obj.product_compliance,
        country_compliance:obj.country_compliance
      });

      console.log(obj.product_compliance);

      if(obj.exact_guid!=''){
        ExactLinkDetails(obj.exact_guid);
      }


    })
    .catch(function (error){
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },3000);
    });
  }




  /*------------------------------------------------------
      SEARCH EXACT
  -------------------------------------------------------*/
  const [searchFound, setSearchFound] = useState(false);
  const [exactSearch, setExactSearch] = useState([]);
  function SearchExactParam(customer_id,search_param){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Searching',text:"Search in progress. Please wait..."}});
    setsubmitSpinner(true);

    let formData = new FormData();
    formData.append('type','search');
    formData.append('search_param',search_param);
    axios.post('/admin/exact/product.php',formData)
    .then(function (response) {
      let obj = response.data;


      if(obj.error){
        setSearchFound(false);
        setExactSearch([]);
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Error Message',text:obj.message}});
        setnotify(true);
        setsubmitSpinner(false);
        return false;
      }

      if(obj.length==0){
        setsubmitSpinner(false);
        setSearchFound(true);
        return false;
      }


      setSearchFound(false);
      setExactSearch(obj);
      
      /*setExactSearch([
        {"ID":"4bdbb4b1-5c23-4c04-ae95-a8a8bd6ab00i","Description":"Vancomycin 250mg/5ml Solution (150ml)"},
        {"ID":"2c51c035-4c04-ae95-a8a8bd6ab00i","Description":"SureEase Maintenance Ring Set 15085"}
      ]);
      setsubmitSpinner(false);
      return false;*/
      console.log(obj);
      setsubmitSpinner(false);



    })
    .catch(function (error){
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
        setsubmitSpinner(false);
      },3000);
    });
  }




  function SaveExactLinkAccount(product_id,exact_guid){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Update Exact Guid',text:"Update in progress. Please wait..."}});
    setsubmitSpinner(true);

    let formData = new FormData();
    formData.append('type','update');
    formData.append('product_id',product_id);
    formData.append('guid',exact_guid);
    axios.post('/admin/exact/product.php',formData)
    .then(function (response) {
      let obj = response.data;

      setsubmitSpinner(false);

      if(obj=='success'){
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:"Exact Guid successfully updated."}});
        setnotify(true);
        setTimeout(function() {
          WindowReload();
          setnotify(false);
        },3000);
        return false;
      }
      if(!obj.error){
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Response message!',text:obj.message}});
        setnotify(true);
        setTimeout(function() {
          WindowReload();
          setnotify(false);
        },3000);
        return false;
      }


      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Error Message!',text:"Exact Guid not successfully updated."}});
      setnotify(true);


    })
    .catch(function (error){
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
        setsubmitSpinner(false);
      },3000);
    });
  }


   /*------------------------------------------------------
      ALERT CONFIRMATION
      {intent:'delete',settings:{id:id,centered:false,onclose:true,icon:'warning',title:'Delete Confirmation!',text:'This process is not ireversible. Once you continue the process, the record will be deleted forever on the database.'}}
    -------------------------------------------------------*/
  const [confirm,setconfirm] = useState(true);
  const [confirmcontent, setconfirmcontent] = useState({});
  function Confirmcallback(data){
    if(data.intent=='close'){
      setconfirm(false);
      if(data.reload){
        WindowReload();
      }
    }
    if(data.intent=='unlink'){
      UnlinkExactGuidConfirm(data.id);
    }
  }


  /*------------------------------------------------------
    UNLINK EXACT
  -------------------------------------------------------*/
  
  function UnlinkExactGuid(id){
    setconfirmcontent({intent:'unlink',settings:{id:id,centered:false,onclose:true,icon:'warning',title:'Unlink Confirmation!',text:'Are you sure you want to remove the exact linked?'}});
    setconfirm(true);
  }
  
  function UnlinkExactGuidConfirm(id){
    
    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Unlink Exact Guid',text:"Unlink in progress. Please wait..."}});
    setspinner(true);
    setconfirm(false);
  
    let formData = new FormData();
    formData.append('type','unlink');
    formData.append('id',id);
    axios.post('/admin/products/request.php',formData)
    .then(function (response) {
        let obj = response.data;
  
        setspinner(false);
  
        if(obj=='success'){
          setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Product successfully unlinked.'}});
          setnotify(true);
          setTimeout(function() {
            WindowReload();
          },2000);
        }else{
          setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Unlink Failed',text:'Exact guid not successfully removed. Please try again.'}});
          setnotify(true);
          setTimeout(function() {setnotify(false);},2000);
        }
  
    })
    .catch(function (error){
      setspinner(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
  }


  /*------------------------------------------------------
    GET DETAILS EXACT
  -------------------------------------------------------*/
  const [exactSpinner, setExactSpinner] = useState(true);
  const [exactData, setExactData] = useState([]);
  function ExactLinkDetails(product_guid){
    let formData = new FormData();
    formData.append('type','details');
    formData.append('product_guid',product_guid);
    axios.post('/admin/exact/product.php',formData)
    .then(function (response) {
        let obj = response.data;
        if(obj.length>0){
          setExactData(obj);
        }
        setTimeout(function() {
          setExactSpinner(false);
        },2000);
        
    })
    .catch(function (error){
      setExactSpinner(false);
      setloader(false);
      //setnofitycontent({intent:'error',settings:{onclose:false,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
    });
 }




  /*------------------------------------------------------
          DROPDOWN OPTIONS
  -------------------------------------------------------*/
  const [statusOptions, setStatusOptions] = useState([]);
  const HandleOptions = async () => {
    const source = await DropdownComponent();
    setStatusOptions(source.status);
  }



  /*---------------------------------------------------------------------------------------------------------------------------------------
         AUTH PERMISSION FOR PAGES
  ----------------------------------------------------------------------------------------------------------------------------------------*/
  const [loader,setloader] = useState(true);
  const [pageId, setPageId] = useState('yt2d71v4r8p36qfwe');
  const [authPages, setAuthPages] = useState({
    view:0,
    adding:0,
    editing:0,
    deleting:0
  });
  function AuthPagesPermission(){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setloader(true);

    let formData = new FormData();
    formData.append('type','authPages');
    formData.append('id',pageId);
    axios.post('/admin/users-management/users-permission/request.php',formData)
    .then(function (response) {
        let obj = response.data;
        setAuthPages({
          view:obj.view,
          adding:obj.adding,
          editing:obj.editing,
          deleting:obj.deleting,
        });

        if(obj.view==1){
            if(params.id){
              ProductDetails(params.id);
            }else{
              WindowLocation('/products/list');
              return false;
            }
        }
        setloader(false);
        setspinner(false);

    })
    .catch(function (error){
      setloader(false);
      setspinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
 }

  useEffect(()=>{
    AuthPagesPermission();
    HandleOptions();
  },[]);

  return (
    <React.Fragment>


      {confirm&&<AlertConfirmation data={confirmcontent} callback={Confirmcallback}/>}
      {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
      {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}
      {submitSpinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

      {((authPages['view']==0||authPages['editing']==0)&&!spinner)&&<AuthDenied/>}
      {(authPages['view']==1&&!spinner)&&<React.Fragment>

      <div className="page-wrapper-one">
        <div className="app-page-title">
         <div className="page-title-wrapper">
            <div><h1>Edit Product</h1></div>
            <div>
              <Button className='LightGrayButton strong' size='tiny' content='Refresh' icon='sync alternate icon' onClick={()=>WindowReload()}/>
              <Button className='GreenButton strong' size='tiny' content='Back to list' icon='arrow left icon' as="a" href={WindowURL('/products/list')}/>
            </div>
          </div>
       </div>
      <div className="app-body-wrapper">
      <Form>
        <Formik
            enableReinitialize
            initialValues={state}
            validationSchema={ValidateForm}
            onSubmit={handleSubmitForm}
            render={formProps => {
            const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue } = formProps
            return(
                    <div className="page-form-panel">
                        <div className="page-form-body">
                        <div class="alert-message left error">
                            <div><i class="info circle icon"></i></div>
                            <div><p>Fields with asterisk is required.</p></div>
                        </div>
                        <br/>


                        {/* Layout Form 2 Column*/}
                        <div className="layout-one-column">
                              <div>


                                      <Form.Group widths="equal">
                                        <Field name="name">
                                            {({ field, form }) => (
                                            <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                              <label>Name</label>
                                              <Input {...field} onChange={handleChange}/>
                                              { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                            </Form.Field>
                                            )}
                                          </Field>
                                      </Form.Group>
                                      <Form.Group widths="equal">
                                        <Field name="code">
                                              {({ field, form }) => (
                                              <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                <label>Code</label>
                                                <Input {...field} onChange={handleChange}/>
                                                { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                              </Form.Field>
                                              )}
                                        </Field>
                                      </Form.Group>

                                      <Form.Group widths="equal">
                                        <Field name="price">
                                            {({ field, form }) => (
                                            <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                              <label>Selling Price</label>
                                              <Cleave {...field}
                                                    onChange={event => {
                                                      setFieldValue('price',event.target.rawValue);
                                                  }} options={{numeral: true, numeralThousandsGroupStyle: 'thousand', prefix:CurrencySymbol()+' ', rawValueTrimPrefix: true}}/>
                                              { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                            </Form.Field>
                                            )}
                                        </Field>
                                      </Form.Group>

                                      <Form.Group widths="equal">
                                        <Field name="status">
                                          {({ field, form }) => (
                                              <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                <label>Status</label>
                                                <Select
                                                    selectOnBlur={false}
                                                    {...field}
                                                    options={statusOptions}
                                                    onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                                                { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                              </Form.Field>
                                          )}
                                        </Field>
                                      </Form.Group>

                                      <Form.Group widths="equal">
                                        <Field name="description">
                                            {({ field, form }) => (
                                            <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                              <label>Description</label>
                                              <TextArea {...field} onChange={handleChange}/>
                                              { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                            </Form.Field>
                                            )}
                                        </Field>
                                      </Form.Group>


                                      {values.product_compliance.length>0&&<div className="compliance-wrapper">
                                        <div class="ui attached tabular menu">
                                          <a class="active item">Additional Compliance Statement</a>
                                        </div>
                                        <div class="ui bottom attached segment active tab">
                                          <FieldArray
                                            name="product_compliance"
                                            render={arrayHelpers => (
                                              <div>
                                                  {values.product_compliance.map(function(data, key){
                                                    return<Form.Group inline>
                                                      <Form.Checkbox name="product_compliance" defaultChecked={data.is_check==1?'true':''}  id={'product_compliance'+key} label={data.message}
                                                        onChange={e => {

                                                          if(e.target.checked){
                                                            setFieldValue(`product_compliance[${key}].is_check`,1);
                                                          }else{
                                                            setFieldValue(`product_compliance[${key}].is_check`,0);
                                                          }

                                                        }}
                                                      />
                                                  </Form.Group>
                                                })}
                                                </div>
                                              )}/>
                                        </div>
                                    </div>}


                                    {values.country_compliance.length>0&&<div className="compliance-wrapper">
                                      <div class="ui attached tabular menu">
                                        <a class="active item">Country Compliance Statement</a>
                                      </div>
                                      <div class="ui bottom attached segment active tab">
                                        <FieldArray
                                          name="country_compliance"
                                          render={arrayHelpers => (
                                              <div>
                                                {values.country_compliance.map(function(data, key){
                                                  return<Form.Group inline>
                                                    <Form.Checkbox name="country_compliance" defaultChecked={data.is_check==1?'true':''}  id={'country_compliance'+key} label={data.message}
                                                      onChange={e => {

                                                        if(e.target.checked){
                                                          setFieldValue(`country_compliance[${key}].is_check`,1);
                                                        }else{
                                                          setFieldValue(`country_compliance[${key}].is_check`,0);
                                                        }

                                                      }}
                                                    />
                                                  </Form.Group>
                                                })}
                                              </div>
                                            )}/>
                                      </div>
                                    </div>}


                                {/*--------------------------------------------------------------------------------
                                 Left column : End
                                ---------------------------------------------------------------------------------*/}
                                </div>

                                <div>
                                  <div className="exact_Panel">
                                    <div className="exact_Panelheader">
                                        <h3>Exact Guid</h3>
                                    </div>
                                    <div className="exact_Panelbody">

                                        {/*<Form.Group widths="equal">
                                            <Field name="exact_guid">
                                                {({ field, form }) => (
                                                <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                  <label>Exact Guid</label>
                                                  <Input readOnly={values.exact_guid_copy!=''} {...field} onChange={handleChange}/>
                                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                                </Form.Field>
                                                )}
                                            </Field>
                                        </Form.Group>*/}

                                        {values.exact_guid_copy==''&&<Form.Group widths="equal">
                                            <Field name="search_param">
                                                {({ field, form }) => (
                                                <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                  <Input {...field} onChange={handleChange} Placeholder='search'/>
                                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                                </Form.Field>
                                                )}
                                            </Field>
                                        </Form.Group>}

                                        {values.exact_guid_copy!=''&&<div class="alert-message left info" style={{'margin-bottom':'15px'}}>
                                           <div><i class="info circle icon"></i></div>
                                           <div>
                                              <p>Product is already linked to Exact. No action is needed.</p>
                                           </div>
                                       </div>}

                                       {values.exact_guid_copy!=''&&<Table definition>
                                       {exactSpinner&&<TableBody><TableRow><TableCell>
                                          <Loader active inline='centered' />
                                        </TableCell></TableRow></TableBody>}
                                       {!exactSpinner&&<React.Fragment>
                                       {exactData.map(function(data, key){
                                          return<TableBody key={key}>
                                                    <TableRow>
                                                      <TableCell style={{'width':'150px'}}>ID</TableCell>
                                                      <TableCell>{data.ID}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell>Code</TableCell>
                                                      <TableCell>{data.Code}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell>Description</TableCell>
                                                      <TableCell>{data.Description}</TableCell>
                                                    </TableRow>
                                                
                                              </TableBody>})}
                                            </React.Fragment>}
                                      </Table>}


                                        {searchFound&&<div class="alert-message left warning" style={{'margin-bottom':'15px'}}>
                                           <div><i class="info circle icon"></i></div>
                                           <div>
                                              <h3 style={{'font-weight':'700'}}>Search result</h3>
                                              <p>(0) result found. Try your search again.</p>
                                           </div>
                                       </div>}


                                      {(exactSearch.length>0&&!searchFound)&&<Table celled compact='very'>
                                        <Table.Header>
                                          <Table.Row verticalAlign='middle'>
                                            <Table.HeaderCell colSpan='2' collapsing style={{'font-weight':'700','background-color':'#fffaf3','color':'#573a08'}}>({exactSearch.length}) result{exactSearch.length>1?"'s":''} found</Table.HeaderCell>
                                          </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                        {exactSearch.map(function(data, key){
                                            return <Table.Row verticalAlign='middle' positive={data.ID==values.exact_selected&&values.exact_selected!=0} onClick={()=>{
                                                    setFieldValue('exact_selected',data.ID);
                                                    setFieldValue('exact_guid',data.ID);
                                                }}>
                                                <Table.Cell style={{'cursor':'pointer','width':'1%'}} collapsing>
                                                  {data.ID==values.exact_selected&&values.exact_selected!=0&&<i className='uil-check icon' style={{'color':'#21ba45'}}></i>}
                                                  {/*data.ID!=values.exact_selected&&<i className='uil-check icon'></i>*/}
                                                </Table.Cell>
                                                <Table.Cell style={{'cursor':'pointer'}} collapsing>
                                                  <div style={{'font-weight':'800','color':'#344050'}}>{data.Description}</div>
                                                  <div style={{'opacity':'0.7'}}>{data.ID}</div>
                                                </Table.Cell>
                                              </Table.Row>
                                            })}
                                          </Table.Body>
                                        </Table>}

                                         {values.exact_guid_copy==''&&<Form.Group inline>
                                            <Button disabled={values.search_param==''} className='LightGrayButton strong' size='tiny' content='Search'  icon='search icon' style={{'margin-right':'20px'}} onClick={()=>{
                                                SearchExactParam(values.id,values.search_param)
                                            }}/>
                                            <Button disabled={values.exact_guid==''} className='BlueButton strong' size='tiny' content='Update'  icon='save icon' style={{'margin-right':'20px'}} onClick={()=>{
                                                SaveExactLinkAccount(values.id,values.exact_guid)
                                            }}/>
                                        </Form.Group>}

                                      </div>

                                      {values.exact_guid_copy!=''&&<div className="exact_Panelfooter">
                                          <div className="exact_Panelfooterflex">
                                              <div><Button disabled={exactSpinner} className='RedButton' size='mini' content='Unlink Exact' icon='unlink icon' onClick={()=>UnlinkExactGuid(values.id)} /></div>
                                              <div><Button disabled={exactSpinner} className='YellowButton' size='mini' content='Exact Link' icon='arrow right icon' labelPosition='right' as="a" target='_blank' rel='noreferrer' href={'https://start.exactonline.co.uk/docs/SlsSalesOrderEntry.aspx?EntryID={'+values.exact_guid+'}&_Division_=20010'}/></div>
                                          </div>
                                    </div>}

                                    </div>
                                </div>

                              {/*--------------------------------------------------------------------------------
                                 Right column : End
                                ---------------------------------------------------------------------------------*/}


                        </div>
                                

                        </div>{/*.page-form-body*/}

                        <div className="page-form-footer">
                            <Button disabled={spinner||authPages['editing']==0} className='LightGrayButton strong' size='small' content='Save and back to list' icon='save icon' onClick={() => buttonSubmit(1)}/>
                            <Button disabled={spinner||authPages['editing']==0} className='PrimaryButton strong' size='small' content='Save and stay on page' icon='save icon' onClick={() => buttonSubmit(2)}/>
                            <button type="button" className="display_none" ref={buttonEl} onClick={handleSubmit}></button>
                        </div>

                 </div>

            )}}/>
          </Form>
          </div>
        </div>
      </React.Fragment>}
    </React.Fragment>
  )
}
